<template>
  <div class="profile">
    <MainBackButton />

    <div class="theme" @click="$store.commit('toggleTheme')">
      <img src="/img/home2/sun-moon.svg" class="wiggle" />
    </div>

    <!-- <section class="hero bg-fancy" :class="theme"> -->
    <section class="hero gradient-pattern" :class="theme">
      <div class="hero-body"></div>

      <div class="columns is-mobile" style="padding-bottom: 6px">
        <div class="column tab" :class="{ selected: tab === 'user' }" @click="setTab('user')">
          <i class="fa fa-user fa-sm" />&nbsp;User
        </div>
        <div class="column tab" :class="{ selected: tab === 'roles' }" @click="setTab('roles')">
          <i class="fa fa-briefcase fa-sm" />&nbsp;Roles
        </div>
      </div>
    </section>

    <input type="file" ref="file" style="display: none" accept="image/png,image/jpeg,image/jpg,image/bmp"
      @change="setPicAWS($event)" />

    <figure class="image" :class="theme">
      <img v-if="$store.getters.isLoggedIn" v-webp="$store.getters.profilePic" @click="$refs.file.click()"
        @error="defaultImg" />
      <img v-else :src="$store.state.birdProfilePic" @click="oldLineLogin" />
    </figure>

    <div class="tabs-div">
      <ProfileInfoTab v-show="tab === 'user'" />
      <ProfileBusinessTab v-show="tab === 'roles'" />
      <ProfileTripsTab v-show="tab === 'trips'" />
    </div>
  </div>
</template>


<script>
import EventBus from "../eventBus";
import imageCompression from "browser-image-compression";
import { lineLogin } from "../functions.js";
import ProfileInfoTab from "@/components/ProfileInfoTab";
import MainBackButton from "@/components/MainBackButton";
import ProfileBusinessTab from "@/components/ProfileBusinessTab";
import ProfileTripsTab from "@/components/ProfileTripsTab";
// import ProfileFavoritesTab from "@/components/ProfileFavoritesTab";

export default {
  name: "Profile",
  components: {
    MainBackButton,
    ProfileInfoTab,
    ProfileTripsTab, // move this somewhere else later...now semi-hidden
    ProfileBusinessTab,
  },
  data() {
    return {
      tab: "user",
      imgFallback: {
        loading: this.$store.state.birdProfilePic,
        error: this.$store.state.errorProfilePic,
      },
    };
  },
  computed: {
    theme() {
      return this.$store.state.theme;
    },
  },
  activated() {
    this.updateRecentTransactionsForCustomer();
    this.updateOngoingTransactionsForCustomer();
    this.checkQuery();
  },
  mounted() {
    this.updateUser();
    if (this.$route.query.set_profile_pic) this.$refs.file.click();
    else this.checkProfilePic();

    this.console("this.$route", this.$route);
    this.$cookies.set("full_path", this.$route.fullPath);
    EventBus.$emit("ROUTE", this.$route);
    EventBus.$on("SET_PROFILE_PIC", () => this.$refs.file.click());

    this.checkLineOAuth();

    // if user_id is set in query, means LIFF Login
    var lineUserID = this.$route.query.user_id;
    if (lineUserID) {
      this.$store.dispatch("login", lineUserID);
      // lineUsersGet(lineUserID, this.$cookies);
    }

    // means LINE Login, not LIFF Login
    EventBus.$on("LINE_LOGIN_SUCCESS", (lineUserData) => {
      this.console("line login success");
      this.$store.dispatch("login", lineUserData.line_user_id);
      // lineUsersGet(lineUserData.line_user_id, this.$cookies);
    });

    // check if already logged in
    if (this.$cookies.isKey("line_user") && !this.$cookies.isKey("user")) {
      var lineUserData = this.$cookies.get("line_user");
      this.$store.dispatch("login", lineUserData.line_user_id);
      // lineUsersGet(lineUserData.line_user_id, this.$cookies);
    }

    if (!this.$store.getters.isLoggedIn) {
      EventBus.$emit("OPEN_LOGIN_MODAL", "");
    }

    this.checkQuery();
    if (this.$route.path !== this.$route.fullPath) {
      this.$router.replace(this.$route.path); // clear the query
    }
    if (this.$store.getters.isLoggedIn) {
      this.$store.dispatch("getRoles", this.$store.state.user.id);
    }
  },
  methods: {
    defaultImg(e) {
      e.target.src = this.$store.state.errorProfilePic;
    },
    setTab(tab) {
      if (tab === "roles") this.updateRoles(false);
      this.tab = tab;
    },
    tabClass(tab) {
      if (this.tab === tab) return "has-text-black"; //"has-text-warning";
      return "has-text-grey"; //"has-text-info";
    },
    checkQuery() {
      var query = this.$route.query;
      if (query.action == "add") {
        if (query.business_id == "raintree") {
          if (query.role == "customer") {
            this.$cookies.set("raintree", "customer");
          }
          if (query.role == "driver") {
            this.$cookies.set("raintree", "driver");
          }
        }
      }
      if (query.apple_user) {
        console.log("login apple_user", query.apple_user);
        var loader = this.loadingDots("lightblue");
        this.$store
          .dispatch("appleUser", query.apple_user)
          .then((res) => console.log("appleUser", res))
          .catch((err) => this.apiError(err))
          .finally(() => {
            loader.hide();
            this.$nextTick(() => this.checkMobileNumber());
          });
      }
      if (query.tab) {
        // this.setTab(query.tab);
        this.tab = query.tab;
        if (query.tab === "Business" && query.tab2) {
          EventBus.$emit("SET_BUSINESS_TAB", query.tab2);
        }
        if (query.tab === "Trips" && query.tab2) {
          EventBus.$emit("SET_TRIPS_TAB", query.tab2);
        }
      }
    },
    checkLineOAuth() {
      this.console("checkLineOAuth", this.$route.query.code, this.$route);
      if (this.$route.query.code != null) {
        var redirect = this.$router.currentRoute.path; // redirect back here
        var code = this.$route.query.code;
        this.$store.dispatch("lineOAuthLogin", {
          code: code,
          redirect: redirect,
        });
      }
    },
    oldLineLogin() {
      lineLogin(this.$router.currentRoute.path);
    },
    setPicAWS(e) {
      if (!e.target.files) return;
      if (e.target.files.length === 0) return;
      var originalFile = e.target.files[0];

      var loader = this.loadingDots();
      var options = {
        maxSizeMB: 0.3,
        maxWidthOrHeight: 400,
        useWebWorker: true,
      };
      imageCompression(originalFile, options)
        .then((compressedFile) => {
          var sizeKB = Math.round(compressedFile.size / 1024);
          this.console(`compressedFile size ${sizeKB} KB`); // smaller than maxSizeMB

          imageCompression
            .getDataUrlFromFile(compressedFile)
            .then((base64) => {
              var data = {
                name: this.$shortid.generate() + ".png",
                content: base64.replace(/^data:image\/[a-z]+;base64,/, ""),
                businessID: "users", //this.role.business_id,
                imageType: "profile", //"digital_menu"
              };
              this.$store
                .dispatch("uploadImageAWS", data)
                .then((res) => {
                  console.log("uploadImageAWS", res.data);
                  // var url = JSON.parse(res.data.body).Location;
                  // this.items[this.picIndex].pic = url;
                  var newProfilePic = res.data.compressed_image_url;
                  this.$store
                    .dispatch("setProfilePic", newProfilePic)
                    .then(() => this.successToast("Success!"))
                    .catch((err) => this.apiError(err));
                })
                .catch((err) => this.apiError(err))
                .finally(() => loader.hide());
            })
            .catch((err) => this.console("imageData error", err));
        })
        .catch((err) => this.console("imageCompression error", err));
    },
  },
};
</script>

<style scoped>
.hero {
  background-color: #f0be45;
  overflow: hidden;
  height: 180px;
  /* box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.5); */
}

.dark.hero {
  /* background-color: #1c37bd; */
  background-color: var(--crypto-primary);
  /* background-color: #1f1b24; */
  /* background-color: rgb(59, 59, 59); */
}

/* .has-bg-img {
  background: url("../assets/hero-islands.jpg") center center;
  background-size: cover;
  height: 25vh;
} */
figure {
  position: absolute;
  top: 40px;
  left: 50%;
  transform: translate(-50%, 0);
}

figure img {
  object-fit: cover;
  height: 96px;
  width: 96px;
  border-radius: 50%;
  border: 3px solid #f5d252;
  /* box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.35); */
  /* border-radius: 30%; */
  /* border: 4px solid gold; */
  /* background: url("../assets/live-stripes.jpg"); */
  /* padding: 2px; */
}

.dark img {
  /* border: 3px solid #1c37bd; */
  border: 3px solid var(--crypto-secondary);
  /* #2693da; */
}

.columns {
  margin-bottom: -15px;
  padding: 0;
  z-index: 1;
  padding-top: 10px;
  background-image: linear-gradient(transparent, rgba(0, 0, 0, 0.4));
  /* rgba(0, 0, 0, 0.1) 20%, */
}

column {
  padding: 0 !important;
}

hr {
  margin: 0 0;
}

.field-name {
  margin-bottom: 0;
  line-height: 0pt;
}

.profile {
  height: 100vh;
  width: 100vw;
  overflow: hidden;
}

.dark .tab {
  color: white;
}

.selected {
  opacity: 1 !important;
  font-size: 1.15em;
}

.tab {
  opacity: 0.6;
  text-shadow: 0px 0px 1px rgba(0, 0, 0, 0.5);
}

.circle {
  background-color: #f5d252;
  border-radius: 50%;
  position: fixed;
}

.dark .circle {
  /* background-color: rgb(48, 48, 211); */
  /* background-color: #2693da; */
  background-color: #1c37bd;
  /* .dark .triangle { */
  /* border-bottom: 400px solid #1c37bd; */
}

.theme {
  position: absolute;
  top: 0;
  right: 0;
  margin: 10px;
  z-index: 1;
}

.theme img {
  box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.55);
  height: 40px;
  width: 40px;
  padding: 8px;
  background-color: white;
  border-radius: 50%;
}

.crypto-pattern {
  background-image: url("/img/home2/home-dots-pattern.png");
  background-size: cover;
  /* contain */
  background-position: center;
}

.gradient-pattern {
  background: linear-gradient(0deg,
      #ffc800 0%,
      white 100%);
}

.dark.gradient-pattern {
  background: linear-gradient(0deg,
      var(--crypto-primary) 0%,
      var(--crypto-secondary) 100%);
}

.bg-fancy {
  background-color: #fdfdfd;
  opacity: 1;
  background-image: linear-gradient(135deg, #ffd12f 25%, transparent 25%),
    linear-gradient(225deg, #ffd12f 25%, transparent 25%),
    linear-gradient(45deg, #ffd12f 25%, transparent 25%),
    linear-gradient(315deg, #ffd12f 25%, #fdfdfd 25%);
  background-position: 11px 0, 11px 0, 0 0, 0 0;
  background-size: 22px 22px;
  background-repeat: repeat;
}

.dark.bg-fancy {
  background-color: #434343;
  opacity: 1;
  background-size: 11px 11px;
  background-image: repeating-linear-gradient(45deg,
      #2f53ff 0,
      #2f53ff 1.1px,
      #434343 0,
      #434343 50%);
}
</style>